<template>
    <div>
        <v-btn x-small fab class="btnRefreshTable"
            :loading="loading"                      
            color="info" 
            title="Actualizar Tabla" 
            @click="cargar">
            <v-icon>refresh</v-icon>            
        </v-btn>
        <span class="contadorRegresivo" >{{segundosEspera}}</span>  
    </div>
</template>

<script>
export default {
  props: {
    funcion: Function, // función a ejecutar        
  },
  data() {
    return { fab: false,
      name: "RefreshButton",
      loading: false,  
      segundosEspera: "",    
      tiempoEspera: 15,
    };
  },
  methods: {
      cargar: function(){
          this.segundosEspera = this.tiempoEspera;
          this.loading = true;
          this.cuentaRegresiva();
          this.funcion();          
          var thisObj = this;
          setTimeout(function(){
              thisObj.loading = false;
          }
          ,thisObj.tiempoEspera*1000)  //milisegundos
          
      },    
      cuentaRegresiva() {
        if(this.segundosEspera > 0) {
            setTimeout(() => {
                this.segundosEspera -= 1
                this.cuentaRegresiva()
            }, 1000)
        } else 
            this.segundosEspera = "";
    }    
  }
};
</script>

<style scoped>
.contadorRegresivo {
    font-size:10px;    
    margin-left: 0px;       
    color:lightgray;    
}
.btnRefreshTable {
    margin-right: 0px !important;
}
</style>
